import styled from 'styled-components';

import { CloseButton } from 'components/Button';
import { colors } from 'theme/theme';

import { TooltipPosition } from './TooltipPosition';
import { TooltipSize } from './TooltipSize';
import { TooltipVariant } from './TooltipVariant';
import { arrowPositionStyles } from './arrowPositionStyles';
import { brandVariantArrowPositionStyles } from './brandVariantArrowPositionStyles';
import { placementStyles } from './placementStyles';
import { variantStyles } from './variantStyles';

export const TargetContainer = styled.div`
  position: relative;
`;

export const TooltipContainer = styled.div<{
  $placement: TooltipPosition;
  $variant: TooltipVariant;
  $targetWidth: number;
  $targetHeight: number;
  $size: TooltipSize;
}>`
  position: absolute;
  border-radius: 4px;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.2);
  font-size: 14px;
  max-width: 300px;
  width: max-content;
  z-index: 10000;

  &::before {
    content: '';
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.2);
    position: absolute;
    height: ${(props) => (props.$size === 'large' ? '30px' : '10px')};
    width: 100%;
    z-index: -1;
  }

  ${(props) =>
    placementStyles(props.$placement, props.$targetWidth, props.$size)}
  ${(props) => variantStyles(props.$variant, props.$placement)}

  ${(props) =>
    ['brand-blue', 'brand-green'].includes(props.$variant)
      ? brandVariantArrowPositionStyles(
          props.$placement,
          props.$targetWidth,
          props.$size,
        )
      : arrowPositionStyles(props.$placement, props.$targetWidth, props.$size)}
`;

export const TooltipWrapper = styled.div<{ $size: TooltipSize }>`
  border-radius: 4px;
  padding: ${(props) => (props.$size === 'large' ? '25px 20px' : '2px 8px')};
`;

export const TooltipCloseButton = styled(CloseButton)`
  position: absolute;
  color: ${colors.lightContentGrey};
  padding: 0;
  right: 5px;
  top: 5px;

  &:hover {
    color: ${colors.brandBlue};
    &:disabled {
      &:hover {
        color: ${colors.lightContentGrey};
      }
    }
  }
`;

export const TooltipOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  z-index: 9999;
`;
